module.exports = __webpack_public_path__ + "media/images/logo-114-3881acc193a875b8593d4a52d5f8e566.png";